import { connect } from 'react-redux';
import { getDataCredential } from '../../../actions';
import { fetchSdkApplication } from '../../../actions/sdkApplications';
import CredentialOverviewTab from './CredentialOverviewTab';
import { getConnectionOrVendorType } from '../../../lib/ResourceUtils';
import has from 'lodash/has';
import { getConnectionFields } from './CredentialOverviewTabContainer.helpers';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;

  const {
    paging: { connAuthById },
    entities: { vendors, sdkApplications },
  } = state;

  const connectionOrVendorType = getConnectionOrVendorType(
    data,
    vendors,
    'credentials_type',
    'vendor_id',
  );

  const { auth_template } = data;
  const connectionFields = (() => {
    if (!connectionOrVendorType || !connAuthById[connectionOrVendorType]) {
      return [];
    }
    const { templates, items } = connAuthById[connectionOrVendorType];
    return getConnectionFields(templates, items, auth_template);
  })();

  const sdkApp =
    data.sdk_application_id && sdkApplications
      ? sdkApplications[data.sdk_application_id]
      : undefined;

  return {
    connectionFields,
    sdkAppName: sdkApp?.name,
    sdkAppUuid: sdkApp?.uuid,
  };
};

export default connect(mapStateToProps, {
  getDataCredential,
  fetchSdkApplication,
})(CredentialOverviewTab);
